import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const assign_installer = ({
  event: {
    user,
    kind,
    data: { installer_name, previous_installer_name },
  },
}) =>
  <div className={kind}>
    {previous_installer_name
      ? <span>{previous_installer_name} was replaced with {installer_name}</span>
      : <span>{installer_name} was assigned</span>}
    {' '}by {user}
  </div>;

assign_installer.propTypes = {
  event: PropTypes.shape({
    user: PropTypes.string.isRequired,
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      installer_name: PropTypes.string.isRequired,
      previous_installer_name: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/assign_installer.jsx